import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { HideToast, ShowToast } from '@/store/toast/actions';
import { WARNING_TOAST_DURATION } from '@/services/constants';

interface ShowToastsProps {
    showModulesLimitReachedToast: () => void;
}

export const useShowToasts = (): ShowToastsProps => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const showModulesLimitReachedToast = () => {
        dispatch(
            ShowToast({
                message: t('savemoduleslimitreached_msg'),
                severity: 'warning',
                duration: WARNING_TOAST_DURATION,
                width: 540,
                onClose: HideToast,
            })
        );
    };
    return { showModulesLimitReachedToast };
};
